import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const getFolderEnvelopes = createAsyncThunk(
  "Docs/getFolderEnvelopes",
  async (parent_folder_id, thunkAPI) => {
    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/docs/folders/${parent_folder_id}/signing-envelopes`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return resp.data?.data;
    } catch (error) {
      if (error.response) {
        return thunkAPI.rejectWithValue(
          error.response.data.errorMessage || error.response.data.message
        );
      } else {
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);
